var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.539063 17V15.25L5.95313 9.64062C6.53125 9.03125 7.00781 8.4974 7.38281 8.03906C7.76302 7.57552 8.04688 7.13542 8.23438 6.71875C8.42188 6.30208 8.51563 5.85937 8.51563 5.39062C8.51563 4.85937 8.39063 4.40104 8.14063 4.01562C7.89063 3.625 7.54948 3.32552 7.11719 3.11719C6.6849 2.90365 6.19792 2.79687 5.65625 2.79687C5.08333 2.79687 4.58333 2.91406 4.15625 3.14844C3.72917 3.38281 3.40104 3.71354 3.17188 4.14062C2.94271 4.56771 2.82813 5.06771 2.82813 5.64062H0.523438C0.523438 4.66667 0.747396 3.8151 1.19531 3.08594C1.64323 2.35677 2.25781 1.79167 3.03906 1.39062C3.82031 0.984374 4.70833 0.781249 5.70312 0.781249C6.70833 0.781249 7.59375 0.98177 8.35938 1.38281C9.13021 1.77865 9.73177 2.32031 10.1641 3.00781C10.5964 3.6901 10.8125 4.46094 10.8125 5.32031C10.8125 5.91406 10.7005 6.49479 10.4766 7.0625C10.2578 7.63021 9.875 8.26302 9.32813 8.96094C8.78125 9.65365 8.02083 10.4948 7.04688 11.4844L3.86719 14.8125V14.9297H11.0703V17H0.539063Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.5c8a19ca4c0b1493ec62837308d5cdb0.svg";
export { ForwardRef as ReactComponent };